/* src/app/FW/components/system/admin/admin.component.scss */
.body {
  padding: 15px;
}
/*# sourceMappingURL=admin.component.css.map */
